export type {
  IconButtonVariant,
  IconButtonSize,
  IconButtonShape,
} from "@faire/slate/private/button/types";

export { IconButton } from "./IconButton";
